<style type="text/css" media="screen" >
.filter-active {
  color: #1dc895 !important;
}

.custome-checkbox .v-input__slot {
  margin: 0px !important;
}

.filter-dialog {
  height: 550px !important;
  border-radius: 20px;
}
.scrolable-box {
  min-height: 440px;
  max-height: 440px;
  overflow-y: scroll;
}
.v-dialog--active {
  overflow-x: hidden !important;
}

.custome-date-picker .v-input {
  font-size: 13px !important;
}

.date-filter {
  width: max-content;
}
.date-filter .v-input__slot .v-input__append-inner {
  margin-top: 4px !important;
}
.date-filter .v-input__slot {
  padding: 0px 0px 0px 10px !important;
  min-height: 33px !important;
}

.day-width,
.month-width {
  width: 60px;
}
.year-width {
  width: 80px;
}

.scrolable-box-2 {
  min-height: 350px;
  max-height: 350px;
  overflow-y: scroll;
}
</style>

<template>
  <div class="shipment-filter">
    <v-dialog
      v-model="dialog.flag"
      width="565"
      class="filter-dialog"
      :scollable="false"
    >
      <v-card>
        <v-card-text class="pa-0">
          <v-row class="border-b">
            <v-col md="12">
              <p
                class="text-right pr-3"
                style="margin-bottom: -10px !important"
              >
                <v-icon color="#8F8F8F" small @click="dialog.flag = false">
                  mdi-window-close
                </v-icon>
              </p>
              <p class="page-title text-center">
                {{ $lang.FILTER_SHIPMENT.toUpperCase() }}
              </p>
            </v-col>
          </v-row>
          <v-row class="border-b px-4">
            <!--  Left Part of th filter -->

            <v-col md="4" class="border-r pl-4">
              <p class="filter-sub-title">{{ $lang.FILTER_USING }}</p>

              <div v-for="(item, i) in filter_option" :key="i">
                <div
                  class="py-1 my-1 cursor-pointer"
                  @click="step = i + 1"
                  v-if="
                    !(
                      item == 'Wholesaler' &&
                      $store.state.user_type == $keys.WHOLESALER
                    )
                  "
                >
                  <span
                    class="filter-options"
                    :class="step == i + 1 ? 'filter-active' : ''"
                    v-if="item"
                    >{{ item }}</span
                  >
                </div>
              </div>
            </v-col>

            <!--  filter section -->
            <v-col md="8" class="border-r px-0 scrolable-box">
              <v-stepper v-model="step" class="elevation-0">
                <v-stepper-items>
                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
                  <!-- $$$$$$$$$$$$$$ RETAILR FILTER $$$$$$$$$$$$$-->
                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
                  <v-stepper-content step="1" class="pa-0 pl-2">
                    <div class="mb-3">
                      <v-text-field
                        v-model="retailer_serch_query"
                        :placeholder="$lang.SEARCH"
                        @keyup="getRetailerList"
                        outlined
                        dense
                        rounded
                        append-icon="mdi-magnify"
                        class="mt-1"
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="scrolable-box-2">
                      <v-checkbox
                        v-for="retailer in retailer_list"
                        :key="retailer.retailer_id"
                        v-model="filter_data.retailer_id_list"
                        :label="retailer.retailer_firm_name"
                        :value="retailer.retailer_id"
                        @change="manageCount"
                        class="ml-2 mt-0 custome-checkbox"
                      >
                        <template v-slot:label>
                          <div>
                            <p class="sub-title-text-dark">
                              {{ retailer.retailer_firm_name }}
                            </p>
                            <p class="select-secondary-text">
                              {{ retailer.retailer_full_address }}
                            </p>
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                  </v-stepper-content>
                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
                  <!-- $$$$$$$$$$$$$$ WHOLESALER FILTER $$$$$$$$$$$$$-->
                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
                  <v-stepper-content step="2" class="pa-0 pl-2">
                    <div class="mb-3">
                      <v-text-field
                        v-model="wholesaler_serch_query"
                        :placeholder="$lang.SEARCH"
                        @keyup="getWholesalerList"
                        outlined
                        dense
                        rounded
                        append-icon="mdi-magnify"
                        class="mt-1"
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="scrolable-box-2">
                      <v-checkbox
                        v-for="item in wholesaler_list"
                        :key="item.wholesaler_id"
                        v-model="filter_data.wholesaler_id_list"
                        :label="item.firm_name"
                        :value="item.wholesaler_id"
                        @change="manageCount"
                        class="ml-2 mt-0 custome-checkbox"
                      >
                        <template v-slot:label>
                          <div>
                            <p class="sub-title-text-dark">
                              {{ item.firm_name }}
                            </p>
                            <p class="select-secondary-text">
                              {{ item.city }}, {{ item.state }}
                            </p>
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                  </v-stepper-content>

                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
                  <!-- $$$$$$$$$$$$$$ STATUS FILTER $$$$$$$$$$$$$-->
                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
                  <v-stepper-content step="3">
                    <v-checkbox
                      v-for="(status, i) in status_options"
                      :key="i"
                      v-model="filter_data.status_list"
                      :label="status"
                      :value="status"
                      @change="manageCount"
                      class="ml-2 mt-0 custome-checkbox"
                    >
                      <template v-slot:label>
                        <div>
                          <p class="sub-title-text-dark">{{ status }}</p>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-stepper-content>

                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
                  <!-- $$$$$$$$$$$$$$ TYPE FILTER $$$$$$$$$$$$$-->
                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
                  <v-stepper-content step="4">
                    <v-checkbox
                      v-for="(type, i) in type_options"
                      :key="i"
                      v-model="filter_data.type_list"
                      :label="type"
                      :value="type"
                      @change="manageCount"
                      class="ml-2 mt-2 custome-checkbox"
                    >
                      <template v-slot:label>
                        <div>
                          <p class="sub-title-text-dark">{{ type }}</p>
                        </div>
                      </template>
                    </v-checkbox>
                  </v-stepper-content>
                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
                  <!-- $$$$$$$$$$$$$$ DATE FILTER $$$$$$$$$$$$$-->
                  <!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->

                  <v-stepper-content step="5" class="px-5">
                    <div class="date-filter">
                      <!-- from date  -->
                      <div>
                        <p class="filter-sub-title">{{ $lang.FROM }}</p>
                        <v-menu
                          bottom
                          origin="center center"
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              class="d-flex flex-row elevation-0 custome-date-picker"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-card class="px-1 elevation-0">
                                <p class="sub-title-text-dark pb-1">
                                  {{ $lang.DAY }}
                                </p>
                                <v-text-field
                                  v-model="filter_form_day"
                                  placeholder="DD"
                                  outlined
                                  dense
                                  single-line
                                  maxlength="2"
                                  readonly
                                  append-icon="mdi-menu-down"
                                  class="day-width"
                                ></v-text-field>
                              </v-card>
                              <v-card class="px-1 elevation-0">
                                <p class="sub-title-text-dark pb-1">
                                  {{ $lang.MONTH }}
                                </p>
                                <v-text-field
                                  v-model="filter_form_month"
                                  placeholder="MM"
                                  outlined
                                  dense
                                  single-line
                                  readonly
                                  append-icon="mdi-menu-down"
                                  class="month-width"
                                ></v-text-field>
                              </v-card>
                              <v-card class="px-1 elevation-0">
                                <p class="sub-title-text-dark pb-1">
                                  {{ $lang.YEAR }}
                                </p>
                                <v-text-field
                                  v-model="filter_form_year"
                                  placeholder="YYYY"
                                  outlined
                                  dense
                                  single-line
                                  append-icon="mdi-menu-down"
                                  class="year-width"
                                ></v-text-field>
                              </v-card>
                            </div>
                          </template>
                          <v-date-picker
                            v-model="form_date"
                            @change="dateCahngeHandler()"
                            :max="today"
                            style="z-index: 5"
                          >
                          </v-date-picker>
                        </v-menu>
                      </div>
                      <!--  To date -->
                      <div>
                        <p class="filter-sub-title">{{ $lang.TO }}</p>
                        <v-menu
                          bottom
                          origin="center center"
                          transition="scale-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              class="d-flex flex-row elevation-0 custome-date-picker"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-card class="px-1 elevation-0">
                                <p class="sub-title-text-dark pb-1">
                                  {{ $lang.DAY }}
                                </p>
                                <v-text-field
                                  v-model="filter_to_day"
                                  placeholder="DD"
                                  outlined
                                  dense
                                  single-line
                                  maxlength="2"
                                  readonly
                                  append-icon="mdi-menu-down"
                                  class="day-width"
                                ></v-text-field>
                              </v-card>
                              <v-card class="px-1 elevation-0">
                                <p class="sub-title-text-dark pb-1">
                                  {{ $lang.MONTH }}
                                </p>
                                <v-text-field
                                  v-model="filter_to_month"
                                  placeholder="MM"
                                  outlined
                                  dense
                                  single-line
                                  readonly
                                  append-icon="mdi-menu-down"
                                  class="month-width"
                                ></v-text-field>
                              </v-card>
                              <v-card class="px-1 elevation-0">
                                <p class="sub-title-text-dark pb-1">
                                  {{ $lang.YEAR }}
                                </p>
                                <v-text-field
                                  v-model="filter_to_year"
                                  placeholder="YYYY"
                                  outlined
                                  dense
                                  single-line
                                  append-icon="mdi-menu-down"
                                  class="year-width"
                                ></v-text-field>
                              </v-card>
                            </div>
                          </template>
                          <v-date-picker
                            v-model="to_date"
                            @change="dateCahngeHandler()"
                            :min="form_date"
                            :max="today"
                          >
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </div>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-row>
            <v-col md="6">
              <p class="sub-title-text-dark">
                {{ $lang.FILTER_SELECTED }}:
                  {{filter_count}}
              </p>
            </v-col>
            <v-col md="6" class="text-right">
              <v-btn text color="primary" @click="clearFIlter" class="mr-3">
                <span class="messge-text-green fs-13 underline">
                  {{ $lang.CLEAR_ALL }}
                </span>
              </v-btn>
              <v-btn color="primary" @click="applyFilter" width="90">
                <span class="fs-13 font-bold px-4"> {{ $lang.APPLY }} </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ["filter_data", "dialog"],
  data() {
    return {
      step: 1,
      filter_option: ["Retailer", "Wholesaler", "Status", "Type", "Date"],
      status_options: [
        "Confirmation Pending",
        "Confirmed",
        "Picked up",
        "Dropped at Warehouse",
        "Out for Delivery",
        "Delivered",
        "On Hold",
        "Return",
        "Partial Return",
        "Dropped at Warehouse Return",
        "Withdraw Initiated",
        "Withdrawn",
        "Cancelled",
      ],
      type_options: ["Cash", "Credit"],

      today: new Date().toISOString().substr(0, 10),
      form_date: new Date().toISOString().substr(0, 10),
      to_date: new Date().toISOString().substr(0, 10),

      filter_form_day: null,
      filter_form_month: null,
      filter_form_year: null,
      filter_to_day: null,
      filter_to_month: null,
      filter_to_year: null,

      retailer_serch_query: "",
      retailer_list: [],
      wholesaler_serch_query: "",
      wholesaler_list: [],
      filter_count: 0,
    };
  },

  created() {
    console.log("created");
    this.getRetailerList();
    this.setDisplayDate();
    if (this.$store.state.user_type != this.$keys.WHOLESALER)
      this.getWholesalerList();
  },

  methods: {
    getRetailerList() {
      console.log("methods_1");
      const self = this;
      let params = {
        search_query: self.retailer_serch_query,
      };
      self.loading = true;
      const successHandler = (response) => {
        console.log(response);
        self.retailer_list = response.data.retailer_list;
      };
      const finallyHandler = () => {
        self.loading = false;
      };
      self.request_GET(
        self,
        self.$urls.RETAILER_LIST,
        params,
        successHandler,
        null,
        null,
        finallyHandler
      );
    },
    getWholesalerList() {
      console.log("methods_2");
      const self = this;
      let params = {
        search_query: self.wholesaler_serch_query,
      };
      self.loading = true;
      const successHandler = (response) => {
        self.wholesaler_list = response.data.wholesaler_list;
      };
      const finallyHandler = () => {
        self.loading = false;
      };
      self.request_GET(
        self,
        self.$urls.WHOLESALER_LIST,
        params,
        successHandler,
        null,
        null,
        finallyHandler
      );
    },

    manageCount() {
      console.log("methods_3");
      let r_len = this.filter_data.retailer_id_list.length;
      let w_len = this.filter_data.wholesaler_id_list.length;
      let s_len = this.filter_data.status_list.length;
      let t_len = this.filter_data.type_list.length;
      let d_len = 0;
      if (this.filter_data.filter_date_from) d_len = 1;
      this.filter_count = r_len + s_len + t_len + d_len + w_len;
    },
    applyFilter() {
      this.filter_data.filter_count = this.filter_count;
      console.log(this.filter_data.filter_count);
      this.dialog.flag = false;
      const self = this;
      this.$store.dispatch("shipment/setShipmentFilter", {
        retailer_id_list: self.filter_data.retailer_id_list,
        wholesaler_id_list: self.filter_data.wholesaler_id_list,
        status_list: self.filter_data.status_list,
        type_list: self.filter_data.type_list,
        filter_date_from: self.filter_data.filter_date_from,
        filter_date_to: self.filter_data.filter_date_to,
        filter_count: self.filter_data.filter_count,
      });
      this.$emit("filter");

    },

    clearFIlter() {
      console.log("methods_4");
      const self=this
      this.filter_data.retailer_id_list = [];
      this.filter_data.wholesaler_id_list = [];
      this.filter_data.status_list = [];
      this.filter_data.type_list = [];
      this.filter_data.filter_date_from = "";
      this.filter_data.filter_date_to = "";
      this.manageCount();
    },
    dateCahngeHandler() {
      console.log("methods_5");
      this.filter_data.filter_date_from = this.form_date;
      this.filter_data.filter_date_to = this.to_date;
      this.setDisplayDate();
      this.manageCount();
    },
    setDisplayDate() {
      console.log("methods_6");
      console.log(this.form_date);
      let from_date_arr = this.form_date.toString().split("-");
      this.filter_form_day = from_date_arr[2];
      this.filter_form_month = from_date_arr[1];
      this.filter_form_year = from_date_arr[0];

      let to_date_arr = this.to_date.toString().split("-");
      this.filter_to_day = to_date_arr[2];
      this.filter_to_month = to_date_arr[1];
      this.filter_to_year = to_date_arr[0];
    },
  },
};
</script>